import { render, staticRenderFns } from "./districtsEdit.vue?vue&type=template&id=1c8846cf&scoped=true&"
import script from "./districtsEdit.vue?vue&type=script&lang=js&"
export * from "./districtsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8846cf",
  null
  
)

export default component.exports